// Live results for Tools::PriceQuoteComponent: fetches the same GET the form would submit and swaps
// in the server-rendered results block. The server is the only renderer; without this the form
// still works as a plain GET.
const DEBOUNCE_MS = 200

function queryFor(form) {
  return new URLSearchParams(new FormData(form)).toString()
}

export function initPriceCalculator(scope = document) {
  scope.querySelectorAll("[data-price-calculator]").forEach((root) => {
    const form = root.querySelector("[data-price-calculator-form]")
    const results = root.querySelector("[data-price-calculator-results]")
    if (!form || !results) return

    root.querySelector("[data-price-calculator-submit]")?.setAttribute("hidden", "")

    let timer = null
    let controller = null

    const refresh = async () => {
      const query = queryFor(form)
      controller?.abort()
      controller = new AbortController()
      try {
        const response = await fetch(`${form.action}?${query}`, {
          headers: { Accept: "text/html" },
          signal: controller.signal,
        })
        if (!response.ok && response.status !== 422 && response.status !== 429) return

        const doc = new DOMParser().parseFromString(await response.text(), "text/html")
        const fresh = doc.querySelector("[data-price-calculator-results]")
        if (!fresh) return

        results.replaceChildren(...fresh.childNodes)
        root.querySelector("[data-price-calculator-link]")?.setAttribute("href", `${form.action}?${query}`)
        // Only the calculator's own page carries the setup in its URL; an article keeps its address.
        if (window.location.pathname === new URL(form.action).pathname) {
          window.history.replaceState(null, "", `${form.action}?${query}`)
        }
      } catch (error) {
        if (error.name !== "AbortError") form.querySelector("[data-price-calculator-submit]")?.removeAttribute("hidden")
      }
    }

    const schedule = () => {
      clearTimeout(timer)
      timer = setTimeout(refresh, DEBOUNCE_MS)
    }

    root.querySelectorAll("[data-price-calculator-stepper]").forEach((stepper) => {
      const input = stepper.querySelector("input")
      stepper.querySelectorAll("[data-price-calculator-step]").forEach((button) => {
        button.removeAttribute("hidden")
        button.addEventListener("click", () => {
          const next = Number(input.value || input.min) + Number(button.dataset.priceCalculatorStep)
          input.value = String(Math.min(Number(input.max), Math.max(Number(input.min), next)))
          schedule()
        })
      })
    })

    form.addEventListener("change", schedule)
    form.addEventListener("input", schedule)
  })
}
